<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section" v-on:click="goTo('/local')">Locals</a>
  </div>
  <h1 class="ui header"><i class="tablet alternate icon"></i><div class="content">Locals</div></h1>
  <div v-if="!locals" class="ui active centered inline loader"></div>
  <div v-if="locals" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <table class="ui very basic compact selectable collapsing  table">
          <thead>
            <tr>
              <th class="azpian">Lista de Locals</th>
              <th class="right aligned">
                <div class="ui category search">
                  <div class="ui icon input field">
                    <input class="prompt" type="text" v-model="search" placeholder="Buscar Local" @change="filteredList">
                      <i class="search icon"></i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="local in locals" :key="local.Local.id">
              <td>
                <h4 class="ui image header">
                  <img v-if="local.Local.url" class="ui tiny image" :src="local.Local.url">
                  <img v-if="!local.Local.url" class="ui tiny image" src="../../assets/name.png">
                  <div class="content">
                    <div class="header">{{local.Local.name}}</div>
                    <!--<div class="sub header">{{local.Local.address}}, {{local.Local.cp}}, {{local.Local.city}}</div>-->
                  </div>
                </h4>
              </td>
              <td class="center aligned">
                <div class="ui button" v-on:click="goTo('/local/' + local.Local.id + '/users')">Listado de usuarios</div>
                <!-- <div class="ui button green" v-on:click="goTo('/local/' + local.Local.id + '/parcels')">Listado de paquetes</div> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'Locals',
  data() {
    return {
      locals: null,
      search: null,
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin') {
        this.getImages()
    } else {
      this.$router.replace('/parcels')
    }
  },
  methods: {
    async getImages() {
      await hapiickApi().get('/v1/images/companies?admin_id='+JSON.parse(localStorage.admin).id)
      .then(request => {
        this.images = JSON.parse(JSON.stringify(request.data.data))
        this.getLocals()
      })
      .catch((error) => {
        console.log('error getting images')
        console.log(error)
      })
    },
    getLocals() {
      hapiickApi().post('/v1/locals', {
          admin_id: JSON.parse(localStorage.admin).id
      })
      .then(request => {
        let locals = JSON.parse(JSON.stringify(request.data.data.locals))
        let allLocals = []
        for (let i = 0; i < locals.length; i++) {
          let url = this.images.find((e) => {
            return (e.key === locals[i].Local.user)
          })
          if (url !== undefined) {
            locals[i].Local.url = url.url
          } else {
            locals[i].Local.url = null
          }
          allLocals.push(locals[i])
        }
        this.locals = allLocals
      })
      .catch(() => console.log('error getting locals'))
    },
    goTo(where) {
      this.$router.push(where)
    },
    filteredList() {
      let clientlist= []
      if (this.search.length == 0) {
        this.getLocals()
      }
      for (var i = 0; i < this.locals.length; i++) {
        if (this.locals[i].locals.name.toLowerCase().includes(this.search.toLowerCase())) {
          clientlist.push(this.locals[i])
        }
      }
      this.locals=clientlist
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Local/Locals.vue